<template>
	<v-container fluid>
		<div class="d-flex py-2">
			<v-spacer />
			<download-csv
				:data="selected"
				:name="`datos_contratos_${new Date().getTime()}.csv`"
				delimiter=";"
				ref="descargarBtn"
			>
				<v-btn text color="primary" small :disabled="selected.length == 0">
					<v-icon left> mdi-download </v-icon>
					Descargar seleccionados
				</v-btn>
			</download-csv>
		</div>
		<v-card>
			<v-data-table
				fixed-header
				:items="clientes"
				:headers="clientesHeader"
				show-select
				v-model="selected"
				item-key="IdContrato"
				:single-select="false"
				:calculate-widths="true"
				:search="search"
				checkbox-color="secondary"
				:loading="loading"
				:footer-props="{
					showFirstLastPage: true,
					showCurrentPage: true,
					itemsPerPageOptions: [10, 25, 50],
				}"
			>
				<template v-slot:body.prepend="{ headers }">
					<table-filters
						:headers="headers"
						:items="clientes"
						v-model="inlineFilters"
					></table-filters>
				</template>

				<template v-slot:item.Identidad="{ item }">
					<v-tooltip bottom>
						<template v-slot:activator="{ on, attrs }">
							<v-btn
								v-on="on"
								v-bind="attrs"
								link
								:to="`/detalles_cliente?idCliente=${item.IdCliente}`"
								color="secondary"
								text
								>{{ item.Identidad }}</v-btn
							>
						</template>
						<span>Detalles del Cliente</span>
					</v-tooltip>
				</template>
				<template v-slot:item.Email="{ item }">
					<v-tooltip bottom>
						<template v-slot:activator="{ on, attrs }">
							<v-btn
								v-on="on"
								v-bind="attrs"
								link
								:href="`mailto:${item.Email}`"
								color="secondary"
								text
								v-show="item.Email"
								>{{ item.Email }}</v-btn
							>
						</template>
						<span>Enviar Email</span>
					</v-tooltip>
				</template>
			</v-data-table>
		</v-card>

		<div
			class="d-flex flex-wrap mt-4"
			style="gap: 16px"
			v-if="$root.acceso('DESCARGAR_CSV_CONTRATOS')"
		>
			<v-btn text color="primary" @click="exportarTodos">
				<v-icon left>mdi-download</v-icon>
				Exportar todos</v-btn
			>
		</div>

		<portal-target name="filter-btn" />
	</v-container>
</template>

<script>
// import axios from "redaxios";
import { processToken, perColumnFilter, parseDate } from "@/utils/index.js";

export default {
	components: { TableFilters: () => import("@/components/TableFilters.vue") },
	data() {
		return {
			selected: [],
			clientes: [],
			loading: true,
			search: null,
			clientesHeader: [
				{ text: "Identificador", value: "Identidad" },
				{ text: "Nombre completo", value: "nombreCompleto" },
				{ text: "Razón Social", value: "RazonSocial" },
				{ text: "Dirección", value: "Direccion" },
				{ text: "Teléfono", value: "Telefono" },
				{ text: "Email", value: "Email" },
			].map((header) => {
				return {
					class: "text-no-wrap sticky-header",
					cellClass: "pa-2 text-no-wrap",
					filter: (value) =>
						perColumnFilter(
							value,
							this.inlineFilters[header.value],
							header.dataType
						),
					dataType: "text",
					...header,
				};
			}),

			inlineFilters: {},
		};
	},
	methods: {
		parseDate,
		exportarTodos() {
			const getDatatype = (key) =>
				(this.clientesHeader.find((h) => h.value == key) || {}).dataType;

			this.selected = this.clientes.filter((con) =>
				Object.entries(con).every(([key, value]) =>
					perColumnFilter(value, this.inlineFilters[key], getDatatype(key))
				)
			);

			this.$nextTick(() => {
				this.$refs.descargarBtn.$el.click();
				this.selected = [];
			});
		},
	},
	mounted() {
		let str = this.$store.getters.getDatosEmpresa;

		const { IdUsuario, IdAgente } = str.iss;
		const IdEmpresa = this.$store.getters.getIdEmpresa;

		axios({
			method: "GET",
			url: `${process.env.VUE_APP_API_URL}/Cliente/GetDTOAllClientes/?Contratacion_FinderFiltersContratacionAPIDTO={"IdEmpresa":${IdEmpresa},"IdUsuario":${IdUsuario},"IdAgente":${IdAgente}}`,
		}).then(({ data }) => {
			data = processToken(data).iss;
			this.clientes = [
				...new Map(data.map((item) => [item.Identidad, item])).values(),
			].map((item) => {
				return {
					...item,
					nombreCompleto: [item.Nombre, item.Apellido1, item.Apellido2]
						.filter((i) => !!i)
						.join(" "),
				};
			});
			this.loading = false;
		});
	},
};
</script>

<style scoped>
.v-data-table /deep/ [role="columnheader"] {
	/* background: #f1f1f1 !important; */
}
</style>